/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.assetLibraryModule')

.directive('bulbAssetlibraryCroppable', ['$rootScope','ASSET_LIBRARY', bulbAssetlibraryCroppable]);

function bulbAssetlibraryCroppable($rootScope, ASSET_LIBRARY) {
  return {
    controllerAs: 'croppableCtrl',
    controller: function() {
      var that = this;
      this.aspectRatio = null;
      this.element = null;
      this.entry = null;
      this.fromProfileImageSelection = false;
      this.imageElement = null;
      this.imageHeight = null;
      this.imageWidth = null;
      this.init = false;
      this.lastMaxSize = null;
      this.rotationDegree = ASSET_LIBRARY.ROTATE.INITIAL_START_DEGREE;

      var cropperProfileOptions = {
        // Wait until the image has been loaded and the cropper instance is ready for cropping
        // and then modify the cropper css to make it look like a profile image selection.
        built: createProfileCropperInstance,
        viewMode: 3,
        aspectRatio: 1,
        checkCrossOrigin: false,
        guides: false,
        highlight: false,
        background: false,
        dragMode: 'move',
        rotatable: true,
        movable: true,
        zoomable: true,
        scalable: false,
        zoomOnWheel: true,
        responsive: true,
        minContainerWidth: that.imageWidth,
        minContainerHeight: that.imageHeight,
        minCanvasWidth: that.imageWidth,
        minCanvasHeight: that.imageHeight,
        minCropBoxWidth:  ASSET_LIBRARY.CROP.MIN_CROP_WIDTH,
        minCropBoxHeight: ASSET_LIBRARY.CROP.MIN_CROP_HEIGHT
      };

      this.updateImageInfo = function() {
        var imageAsset = null;
        var imageWidth = null;
        var imageHeight =null;

        /*
        Need to check if the crop modal is being opened up from the user's user unit because we obtain the
        avatar image in a different manner.
         */
        if(that.fromProfileImageSelection) {
          imageAsset = that.entry;
          imageWidth = imageAsset.width;
          imageHeight = imageAsset.height;
        }else {
          imageAsset = that.entry.image;
          imageWidth = imageAsset.width;
          imageHeight = imageAsset.height;
        }
        var imageScale = 1;

        // not small
        var totalMarginAndPadding;
        var modal = $(that.element).closest('.bulb-assetlibrary-modal-crop');
        var modalWidth;
        {
          var modalBody = modal.find('.bulb-modal-body');

          var modalMarginLeft = modal.css('margin-left');
          var modalMarginRight = modal.css('margin-right');
          var modalPaddingLeft = modal.css('padding-left');
          var modalPaddingRight = modal.css('padding-right');

          var modalBodyMarginLeft = modalBody.css('margin-left');
          var modalBodyMarginRight = modalBody.css('margin-right');
          var modalBodyPaddingLeft = modalBody.css('padding-left');
          var modalBodyPaddingRight = modalBody.css('padding-right');

          var modalMargin = parseInt(modalMarginLeft ? modalMarginLeft : 0) +
                            parseInt(modalMarginRight ? modalMarginRight : 0);
          var modalPadding = parseInt(modalPaddingLeft ? modalPaddingLeft : 0) +
                            parseInt(modalPaddingRight ? modalPaddingRight : 0);
          var modalBodyMargin =  parseInt(modalBodyMarginLeft ? modalBodyMarginLeft : 0) +
                            parseInt(modalBodyMarginRight ? modalBodyMarginRight : 0);
          var modalBodyPadding =  parseInt(modalBodyPaddingLeft ? modalBodyPaddingLeft : 0) +
                            parseInt(modalBodyPaddingRight ? modalBodyPaddingRight : 0);

          modalWidth = modalBody.width();
          totalMarginAndPadding = modalMargin + modalPadding + modalBodyMargin + modalBodyPadding;
        }

        // max width and height
        var maxSize = null;
        {
          /* jshint camelcase: false */
          if (Foundation.utils.is_large_up()) {
            maxSize = ASSET_LIBRARY.CROP.MAX_IMAGE_SIZE_ON_LARGE_DISPLAY;

          /* jshint camelcase: false */
          } else　if (Foundation.utils.is_medium_only()) {
            maxSize = ASSET_LIBRARY.CROP.MAX_IMAGE_SIZE_ON_MEDIUM_DISPLAY;

          } else {
            maxSize = $('body').width() - totalMarginAndPadding;
          }

          if (that.lastMaxSize === maxSize) {
            return;
          }

          that.lastMaxSize = maxSize;
        }

        that.aspectRatio = imageWidth / imageHeight;
        if (that.aspectRatio >= 1) {

          if (imageWidth > maxSize) {
            imageScale = maxSize / imageWidth;
            imageWidth = maxSize;
            imageHeight = imageHeight * imageScale;
          }

        } else {

          if (imageHeight > maxSize) {
            imageScale = maxSize / imageHeight;
            imageWidth = imageWidth * imageScale;
            imageHeight = maxSize;
          }
        }

        that.imageWidth = imageWidth;
        that.imageHeight = imageHeight;

        that.element.css('width', imageWidth);
        that.element.css('height', imageHeight);
        that.imageElement.attr('src', imageAsset.url);
        that.imageElement.css('width', imageWidth);
        that.imageElement.css('height', imageHeight);
        that.imageElement.css('max-width', imageWidth);
        that.imageElement.css('max-height', imageHeight);

        modal.css('min-width', imageWidth +  totalMarginAndPadding);
      };

      this.beginCrop = function() {
        var lastCropRect = null;
        if (that.init) {
          lastCropRect = that.imageElement.cropper('getData', 'rounded');
          that.cropStop();
        }
        that.updateImageInfo();

        that.element.addClass('bulb-cropping');

        // We handle avatar images differently in terms of how the crop box is styled
        if(that.fromProfileImageSelection) {
          that.imageElement.cropper(cropperProfileOptions);
        }else {
          that.imageElement.cropper({
            checkCrossOrigin: false,
            movable: false,
            rotatable: false,
            scalable: false,
            zoomable: false,
            zoomOnTouch: false,
            zoomOnWheel: false,
            responsive: true,
            minContainerWidth: that.imageWidth,
            minContainerHeight: that.imageHeight,
            minCanvasWidth: that.imageWidth,
            minCanvasHeight: that.imageHeight,
            minCropBoxWidth: Math.min(ASSET_LIBRARY.CROP.MIN_CROP_WIDTH, that.imageWidth),
            minCropBoxHeight: Math.min(ASSET_LIBRARY.CROP.MIN_CROP_HEIGHT, that.imageHeight),
            data: lastCropRect || that.entry.cropRect || {}
          });
        }

        that.init = true;
      };

      this.cropSave = function(saveHandler) {

        // This crop data scales based on image size, so it is exactly
        // what we want.
        this.entry.cropRect = this.imageElement.cropper('getData', 'rounded');
        saveHandler(this.entry);
      };

      this.cropStop = function() {
        that.imageElement.cropper('destroy');
        that.element.removeClass('bulb-cropping');
        $rootScope.$apply();
      };

      this.rotateRight = function() {
        /*
          Need to destroy the cropper instance on the image element so that jquery-rotate can detect the image
          element. It can't seem to find it because of all the hidden overlays that cropper appends to the
          image.
         */
        that.imageElement.cropper('destroy');
        that.rotationDegree += ASSET_LIBRARY.ROTATE.CONSTANT_ROTATION_DEGREE;
        that.imageElement.rotate({
          animateTo: that.rotationDegree,
          callback: function () {
            that.imageElement.cropper(cropperProfileOptions);
            // wait for cropper to reinitialize.
            setTimeout(() => {
              that.imageElement.cropper('rotate', $(this).getRotateAngle());
            }, 100);
          },
        });
      };

      function createProfileCropperInstance() {
        var $cropperCropBox = $('.cropper-crop-box');
        var $cropperViewBox = $('.cropper-view-box');
        $cropperCropBox.addClass('cropper-crop-box-profile');
        $cropperViewBox.addClass('cropper-crop-box-profile cropper-view-box-profile');
      }

    },
    link: function(scope, elem, attrs, croppableCtrl) {

      croppableCtrl.entry = scope.entry;
      croppableCtrl.fromProfileImageSelection = scope.fromProfileImageSelection;
      croppableCtrl.element = elem;
      croppableCtrl.imageElement = elem.find('img');

      croppableCtrl.beginCrop();

      $(window).resize(croppableCtrl.beginCrop);
      scope.$on('$destroy', function() {
        $(window).unbind('resize', croppableCtrl.beginCrop);
      });
    }
  };
}
